import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import CircularProgress from '@mui/material/CircularProgress';
import Tooltip from '@mui/material/Tooltip';
import { apiUrl, fetchJson } from '../apiBase';

export default function SuperadminSchoolSwitcher({ fullWidth = false }) {
  const [loading, setLoading] = useState(true);
  const [role, setRole] = useState('');
  const [currentSchool, setCurrentSchool] = useState('');
  const [schools, setSchools] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      try {
        const r = await fetchJson('/superadmin/me');
        if (!r.ok) return;
        const me = await r.json();
        if (!cancelled && me && me.role === 'superadmin') {
          setRole('superadmin');
          setCurrentSchool(me.school_id || '');
          const rs = await fetchJson('/superadmin/schools');
          if (rs.ok) {
            const sj = await rs.json();
            if (!cancelled) setSchools(sj.schools || []);
          }
        }
      } catch (_) {
        // ignore
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    run();
    return () => { cancelled = true; };
  }, []);

  const onChange = async (e) => {
    const val = e.target.value;
    setCurrentSchool(val);
    if (!val) return;
    setSaving(true);
    try {
      const form = new URLSearchParams();
      form.set('school_id', val);
      const res = await fetch(apiUrl('/superadmin/switch_school'), {
        method: 'POST',
        body: form,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        credentials: 'include',
      });
      if (res.ok) {
        // reload admin so downstream components get the updated school claim
        window.location.href = '/admin';
      }
    } catch (_) {
      // ignore
    } finally {
      setSaving(false);
    }
  };

  if (loading || role !== 'superadmin') return null;

  return (
    <Box sx={{ minWidth: fullWidth ? 0 : 200, width: fullWidth ? '100%' : 'auto',
      mr: fullWidth ? 0 : 1, display: 'flex', alignItems: 'center', gap: 1 }}>
      <Tooltip title="Okul değiştir" arrow>
        <FormControl size="small" variant="outlined" fullWidth={fullWidth} sx={{
          minWidth: fullWidth ? 0 : 200,
          '& .MuiOutlinedInput-root': {
            minHeight: fullWidth ? 44 : undefined,
            color: fullWidth ? 'text.primary' : 'white',
            backgroundColor: fullWidth ? 'background.paper' : 'rgba(255,255,255,0.12)',
            '& fieldset': { borderColor: fullWidth ? '#8b95a5' : 'rgba(255,255,255,0.3)' },
            '&:hover fieldset': { borderColor: fullWidth ? 'text.primary' : 'rgba(255,255,255,0.5)' },
            '&.Mui-focused fieldset': fullWidth ? { borderColor: '#1976d2', borderWidth: 3 } : {},
          },
          '& .MuiInputLabel-root': { color: fullWidth ? 'text.secondary' : 'white' },
          '& .MuiSelect-select': fullWidth ? { py: 1.5 } : {},
        }}>
          <InputLabel id="superadmin-school-label">Okul Seç</InputLabel>
          <Select
            labelId="superadmin-school-label"
            id="superadmin-school-select"
            aria-label="Okul seçimi"
            value={currentSchool || ''}
            label="Okul Seç"
            onChange={onChange}
            disabled={saving}
          >
            <MenuItem value=""><em>Seçilmedi</em></MenuItem>
            {(schools || []).map((s) => (
              <MenuItem key={s.id} value={s.id}>{s.display_name || s.name || s.id}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Tooltip>
      {saving ? <CircularProgress size={16} sx={{ color: fullWidth ? 'primary.main' : 'white', flexShrink: 0 }} /> : null}
    </Box>
  );
}
